import React, { useMemo } from "react";
import { ModalState } from "@customer-app/account/views/OperationAquarius/AquariusInner/components/Loyalty/utils/constants";
import { LoyaltyStoreAccess } from "@customer-app/account/views/OperationAquarius/AquariusInner/components/Loyalty/store";
import { RedeemIncentiveModalProps } from "@customer-app/account/views/OperationAquarius/AquariusInner/components/Loyalty/components/modals/RedeemIncentiveModal";
import { Typography } from "@mui/material";
import { Trans } from "react-i18next";
import { typedLocalize, typedLocalizeKey } from "@smartrr/shared/utils/sharedTranslations/localize";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import moment from "moment";

export interface RedeemIncentiveUnpauseDescriptionProps extends RedeemIncentiveModalProps {
  unpauseDate: IPurchaseState["unpauseDate"];
}

export const RedeemIncentiveUnpauseDescription = ({
  incentive,
  unpauseDate,
}: RedeemIncentiveUnpauseDescriptionProps) => {
  const modalState = LoyaltyStoreAccess.useUnpauseModalState();
  const { symbol: currencySymbol } = LoyaltyStoreAccess.useCurrency();
  const stringUnpauseDate = moment(unpauseDate).format("MMMM Do");
  const incentiveTitle = useMemo(
    () =>
      incentive.priceRule.type === "fixed_amount"
        ? typedLocalize("loyalty.xUnitsOff", {
            amount: -incentive.priceRule.value,
            unitName: currencySymbol,
          })
        : typedLocalize("loyalty.xPercentOff", { amount: -incentive.priceRule.value }),
    [incentive]
  );
  if (unpauseDate) {
    switch (modalState) {
      case ModalState.REDEEM_IMMEDIATELY: {
        return (
          <Typography variant="body1" textAlign="center">
            {typedLocalize("loyalty.resumeImmediatelyText", {
              rewardItem: incentiveTitle,
            })}
          </Typography>
        );
      }
      case ModalState.REDEEM_UNPAUSE_DATE: {
        return (
          <Typography variant="body1" textAlign="center">
            <Trans
              i18nKey={typedLocalizeKey("loyalty.resumeOnUnpauseDateText")}
              components={[<span key={0} />, <span key={1} />, <strong key={2} />]}
              values={{
                rewardItem: incentiveTitle,
                date: stringUnpauseDate,
              }}
            />
          </Typography>
        );
      }
      default: {
        return (
          <Typography variant="body1" textAlign="center">
            <Trans
              i18nKey={typedLocalizeKey("loyalty.redeemUnpauseDate")}
              components={[<span key={0} />, <span key={1} />, <span key={2} />, <span key={3} />]}
              values={{
                date: stringUnpauseDate,
              }}
            />
          </Typography>
        );
      }
    }
  }
  return (
    <Typography variant="body1" textAlign="center">
      {typedLocalize("loyalty.redeemNoUnpauseDate")}
    </Typography>
  );
};
